// extracted by mini-css-extract-plugin
export var caption = "SumsubVerifyButton-module--caption--7f350";
export var verifyButton = "SumsubVerifyButton-module--verifyButton--a9f02";
export var verifyButtonWrapper = "SumsubVerifyButton-module--verifyButtonWrapper--a172e";